import Config from "../../config/Config";
const axios = require("axios");

const baseUrlDev = Config.BaseUrlPickupStudentDev;
const bearer = () => {
  return localStorage.getItem("token_redux").replaceAll('"', "");
};
export const decodeQrCode = (query = []) => {
  return new Promise((resolve, reject) => {
    axios
      .get(`${baseUrlDev}user/pickup/decode-qr?${query.join("&")}`, {
        headers: {
          Authorization: `Bearer ${bearer()}`,
        },
      })
      .then((res) => {
        let token = res.headers.authorization;
        if (!res.headers.authorization) {
          token = localStorage.getItem("token_redux");
        }
        if (token) {
          if (!token.includes("Bearer")) {
            token = token.replaceAll("Bearer ", "");
          }
          localStorage.setItem("token_redux", token.replaceAll("Bearer ", ""));
        }
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const requestBooking = (data) => {
  return new Promise((resolve, reject) => {
    axios
      .post(`${baseUrlDev}user/pickup/create_booking`, data, {
        headers: {
          Authorization: `Bearer ${bearer()}`,
        },
      })
      .then((res) => {
        let token = res.headers.authorization;
        if (!res.headers.authorization) {
          token = localStorage.getItem("token_redux");
        }
        if (token) {
          if (!token.includes("Bearer")) {
            token = token.replaceAll("Bearer ", "");
          }
          localStorage.setItem("token_redux", token.replaceAll("Bearer ", ""));
        }
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const statusBooking = (data) => {
  return new Promise((resolve, reject) => {
    axios
      .get(`${baseUrlDev}user/pickup/status_booking`, {
        headers: {
          Authorization: `Bearer ${bearer()}`,
        },
      })
      .then((res) => {
        let token = res.headers.authorization;
        if (!res.headers.authorization) {
          token = localStorage.getItem("token_redux");
        }
        if (token) {
          if (!token.includes("Bearer")) {
            token = token.replaceAll("Bearer ", "");
          }
          localStorage.setItem("token_redux", token.replaceAll("Bearer ", ""));
        }
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const statusBookingById = (pickupId) => {
  return new Promise((resolve, reject) => {
    axios
      .get(`${baseUrlDev}user/pickup/by_pickup_id?pickupId=${pickupId}`, {
        headers: {
          Authorization: `Bearer ${bearer()}`,
        },
      })
      .then((res) => {
        let token = res.headers.authorization;
        if (!res.headers.authorization) {
          token = localStorage.getItem("token_redux");
        }
        if (token) {
          if (!token.includes("Bearer")) {
            token = token.replaceAll("Bearer ", "");
          }
          localStorage.setItem("token_redux", token.replaceAll("Bearer ", ""));
        }
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const comboStudents = (data) => {
  return new Promise((resolve, reject) => {
    axios
      .get(`${baseUrlDev}user/pickup/get_student`, {
        headers: {
          Authorization: `Bearer ${bearer()}`,
        },
      })
      .then((res) => {
        let token = res.headers.authorization;
        if (!res.headers.authorization) {
          token = localStorage.getItem("token_redux");
        }
        if (token) {
          if (!token.includes("Bearer")) {
            token = token.replaceAll("Bearer ", "");
          }
          localStorage.setItem("token_redux", token.replaceAll("Bearer ", ""));
        }
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const comboStudentsClass = (query) => {
  return new Promise((resolve, reject) => {
    axios
      .get(`${baseUrlDev}user/pickup/get_student?${query.join("&")}`, {
        headers: {
          Authorization: `Bearer ${bearer()}`,
        },
      })
      .then((res) => {
        let token = res.headers.authorization;
        if (!res.headers.authorization) {
          token = localStorage.getItem("token_redux");
        }
        if (token) {
          if (!token.includes("Bearer")) {
            token = token.replaceAll("Bearer ", "");
          }
          localStorage.setItem("token_redux", token.replaceAll("Bearer ", ""));
        }
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const comboGrade = (data) => {
  return new Promise((resolve, reject) => {
    axios
      .get(`${baseUrlDev}user/class/all?page=0&size=100`, {
        headers: {
          Authorization: `Bearer ${bearer()}`,
        },
      })
      .then((res) => {
        let token = res.headers.authorization;
        if (!res.headers.authorization) {
          token = localStorage.getItem("token_redux");
        }
        if (token) {
          if (!token.includes("Bearer")) {
            token = token.replaceAll("Bearer ", "");
          }
          localStorage.setItem("token_redux", token.replaceAll("Bearer ", ""));
        }
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};
